import React, { useState, ChangeEvent, FormEvent } from 'react';
import { motion } from 'framer-motion';
import Auth from '@aws-amplify/auth';
import Button from 'components/Button';
import Input from 'components/Input';
import { useNavigate } from 'routeMap';

function Register() {
  const formState = useState({
    username: '',
    password: '',
    name: '',
    phone_number: '',
    submitting: false,
    errorMessage: null,
  });
  const [form] = formState;

  return (
    <motion.div
      initial={{ scale: 0.8 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0.8 }}
      transition={{ duration: 0.2 }}
      className={`w-full max-w-md p-6 bg-white rounded-lg z-10 ${
        form.errorMessage ? 'shake' : ''
      }`}
    >
      {form?.errorMessage ? (
        <ErrorMessage formState={formState} />
      ) : (
        <SignUpForm formState={formState} />
      )}
    </motion.div>
  );
}

const SignUpForm = ({ formState }) => {
  const navigate = useNavigate();
  const [form, setForm] = formState;

  const register = async (submitEvent: FormEvent) => {
    submitEvent.preventDefault();
    setForm({ ...form, submitting: true, errorMessage: false });
    try {
      const newUser = await Auth.signUp({
        username: form.username,
        password: form.password,
        attributes: {
          email: form.username,
          phone_number: form.phone_number,
          name: form.name,
        },
      });
      if (newUser) {
        navigate.confirmSignUp({
          search: {
            username: encodeURIComponent(form.username),
          },
        });
      }
    } catch (signupError) {
      setForm({
        ...form,
        errorMessage: signupError.message,
        submitting: false,
      });
      console.warn(signupError);
      // if (signupError.code === 'UsernameExistsException') {
      //   toast.error(`Sorry, that username is already in use`);
      // }
      // if (signupError.message === 'Invalid phone number format.') {
      //   toast.error(`Sorry, that phone number is invalid`);
      // }
    }
  };

  return (
    <form onSubmit={register}>
      <h2 className="mb-5 text-lg font-semibold text-center text-gray-500">
        Register
      </h2>

      <Input
        autoFocus
        label="Email"
        autoComplete="email"
        value={form.username}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setForm({ ...form, username: e.target.value.toLowerCase() })
        }
        onResetClick={() => setForm({ ...form, username: '' })}
      />

      <Input
        label="Name"
        autoComplete="name"
        value={form.name}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setForm({ ...form, name: e.target.value })
        }
        onResetClick={() => setForm({ ...form, name: '' })}
      />

      <Input
        label="Password"
        type="password"
        autoComplete="new-password"
        value={form.password}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setForm({ ...form, password: e.currentTarget.value })
        }
        onResetClick={() => setForm({ ...form, password: '' })}
      />

      <p className="mb-5 text-gray-500 test-xs">
        New users are restricted to the Demo Organisation. Please{' '}
        <a href="support@jcap.co.uk" className="underline text-jcap-600">
          contact us
        </a>{' '}
        after registration to complete the onboarding process and link your
        email address to a real Organisation.
      </p>

      <Button
        type="submit"
        className="float-right btn"
        disabled={form.submitting}
      >
        Register
      </Button>

      <Button
        className="float-right mr-3 btn btn-white"
        onClick={() => navigate.authenticatorRoot()}
      >
        Cancel
      </Button>
    </form>
  );
};

const ErrorMessage = ({ formState }) => {
  const [form, setForm] = formState;

  return (
    <form
      onSubmit={(e: FormEvent) => {
        e.preventDefault();
        setForm({
          ...form,
          submitting: false,
          errorMessage: null,
          password: '',
          code: '',
          challenge: null,
        });
      }}
    >
      <h2 className="mb-5 text-lg font-semibold text-red-500">
        Authentication Error
      </h2>
      <p className="mb-5 font-semibold text-red-500 test-xs">
        {form?.errorMessage}
      </p>
      <Button className="float-right btn btn-white" autoFocus type="submit">
        Go Back
      </Button>
    </form>
  );
};

export default Register;
